<app-cms-banner-section
  *ngIf="section.__component === componentTypes.BANNER"
  [banner]="section"
  [isHp]="isHp"
>
</app-cms-banner-section>

<app-cms-wysiwyg-section
  *ngIf="section.__component === componentTypes.WYSIWYG"
  [section]="section"
>
</app-cms-wysiwyg-section>

<app-cms-activities-section
  *ngIf="section.__component === componentTypes.ACTIVITIES"
  [section]="section"
>
</app-cms-activities-section>

<app-cms-widget-section
  *ngIf="section.__component === componentTypes.WIDGET"
  [section]="section"
>
</app-cms-widget-section>

<app-cms-advice-section
  *ngIf="section.__component === componentTypes.ADVICE"
  [section]="section"
>
</app-cms-advice-section>

<app-cms-divider-section
  *ngIf="section.__component === componentTypes.DIVIDER"
  [section]="section"
  class="container"
>
</app-cms-divider-section>

<ng-container *ngIf="section.__component === componentTypes.CARDS">
  <app-cms-card-collection-section
    [section]="section"
  ></app-cms-card-collection-section>
</ng-container>

<app-cms-image-section
  *ngIf="section.__component === componentTypes.IMAGE"
  [section]="section"
>
</app-cms-image-section>

<app-cms-offer-section
  *ngIf="section.__component === componentTypes.OFFER"
  [section]="section"
>
</app-cms-offer-section>

<app-cms-picture-and-text-section
  *ngIf="section.__component === componentTypes.PICTURE_AND_TEXT"
  [section]="section"
>
</app-cms-picture-and-text-section>

<app-cms-text-and-blocks-section
  *ngIf="section.__component === componentTypes.TEXT_AND_BLOCK"
  [section]="section"
>
</app-cms-text-and-blocks-section>

<app-cms-pipedrive-webform-section
  *ngIf="section.__component === componentTypes.PIPEDRIVE_WEBFORM"
  [section]="section"
>
</app-cms-pipedrive-webform-section>
